import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * CUSTOMIZATION: Logged-in MyPresidio footer (Presidio theme).
 * Two link columns + copyright/social bar — replaces the marketing CMS footer layout.
 */
@Component({
  selector: 'ish-presidio-storefront-footer',
  templateUrl: './presidio-storefront-footer.component.html',
  styleUrls: ['./presidio-storefront-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslatePipe],
})
export class PresidioStorefrontFooterComponent {
  readonly year = new Date().getFullYear();

  readonly privacyHref = 'https://www.presidio.com/privacy-policy/';
  readonly termsHref = 'https://www.presidio.com/terms-of-use/';
  /** PROVISIONAL: no confirmed public accessibility statement URL yet. */
  readonly accessibilityHref = 'https://www.presidio.com/';

  readonly socialLinks = [
    {
      labelKey: 'footer.social.linkedin',
      href: 'https://www.linkedin.com/company/presidio',
      icon: 'linkedin' as const,
    },
    {
      labelKey: 'footer.social.facebook',
      href: 'https://www.facebook.com/presidio/',
      icon: 'facebook' as const,
    },
    {
      labelKey: 'footer.social.x',
      href: 'https://x.com/Presidio',
      icon: 'x' as const,
    },
    {
      labelKey: 'footer.social.youtube',
      href: 'https://www.youtube.com/@Presidio',
      icon: 'youtube' as const,
    },
    {
      labelKey: 'footer.social.instagram',
      href: 'https://www.instagram.com/presidio/',
      icon: 'instagram' as const,
    },
  ] as const;

}
